<template>
	<div >
		<div style="min-height: 600px;">


			<p class="cpzs-title">金属专利证书</p>

			<p style="text-align: center;margin-bottom: 10px;">———</p>
			<!--<hr />-->
			<div style="margin: 20px 0px 40px 0px;">
				<Row>
					<Col span="12" style="text-align: center;">
						<img src="@/assets/metalcertificate/jszl.jpg" width="400" alt="" >
					</Col>
					<Col span="12" style="text-align: left;padding-top: 30px;">
						<p class="cpzs-smbt">
							价　　格：
							<span style="font-size: 14px;">￥</span>
							<span style="font-size: 30px;color: #E53F40;font-weight: 700;">500</span>
						</p>
						<p class="cpzs-smbt">
							联系单位：
							<span class="cpzs-smnr">北京宇久科技有限公司</span>
						</p>
						<p class="cpzs-smbt">
							联系地址：
							<span class="cpzs-smnr">北京市昌平区回龙观西大街9号院6层1单元709</span>
						</p>
						<p class="cpzs-smbt">
							邮政编码：
							<span class="cpzs-smnr">102206</span>
						</p>
						<p class="cpzs-smbt">
							电　　话：
							<span class="cpzs-smnr">18513835453</span>
						</p>
						<p class="cpzs-smbt">
							电子邮件：
							<span class="cpzs-smnr">cjx@yujiutech.com</span>
						</p>
						<p class="cpzs-smbt">
							汇款银行：
							<span class="cpzs-smnr">中国民生银行股份有限公司北京望京支行</span>
						</p>
						<p class="cpzs-smbt">
							户　　名：
							<span class="cpzs-smnr">北京宇久科技有限公司</span>
						</p>
						<p class="cpzs-smbt">
							账　　号：
							<span class="cpzs-smnr">699277621</span>
						</p>
						<p style="margin-top: 30px;">
							<Button type="primary" @click="downloadHzd">下载回执单</Button>
						</p>
					</Col>
				</Row>
			</div>
			<!--<hr />-->

			<p class="cpzs-title">INTRODUCTION</p>
			<p style="text-align: center;"><small style="text-align: center;color: #a1a1a1;">介绍</small></p>
			<p style="text-align: center;margin-bottom: 10px;">———</p>

			<div class="cpzs-content" style="padding: 0 10%;font-size: 16px;margin-bottom: 50px;">
				<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;专利证书作为专利权人的权利标志，在专利权人的多种经济、技术、商业和法律活动中起着至关重要的作用，是专利权人的有效权利证明，遗失后不能补发。因此，专利证书一直被专利权人视为极其宝贵的财富。</p>
				<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;国家知识产权局授予专利权人的专利证书为纸质套皮式样，且多个发明人只能共有一份专利证书。国家知识产权局中国专利信息中心自九十年代起，采用金属复制的方法为专利权人制作金属专利证书，即在国家知识产权局授予纸质的专利证书后，专利权人可以申请复制一件或数件金属专利证书。</p>
				<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;金属专利证书设计新颖、制作精美，适合收藏纪念，更是专利宣传的一种有效手段。</p>
				<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;申请制作金属专利证书须专利权人提供专利证书复印件。</p>
				<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;金属专利证书可制作成英文版（英文版无国家知识产权局公章），发明名称，发明人、专利权人、地址这四项英文译文须由专利权人提供。产品尺寸，竖版：180*245、横版：245*180。</p>
				<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;金属专利证书价格：500元/件（含邮资）。</p>
				<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;金属专利证书由中国专利信息中心独家负责征订、制作、颁发，具有权威性和唯一性，任何其他单位、部门或个人均不得以任何形式和手段非法仿制。新版证书为竖版，旧版证书为横版（版式以来稿为准）。</p>
				<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;请将下载<a href="/static/metalcertificate/hz.doc">《回执》</a>填写完成后同专利证书复印件（原版）与汇款底单扫描后的电子版通过电子邮件形式发送至联系人邮箱。</p>
				<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span style="color: #626B7D;">特别提示：</span>请在回执中注明汇款人姓名、是否开具发票以及发票抬头如何填写！ </p>
				<p>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span style="color: #626B7D;">免责声明：</span>上述金属专利证书为纪念件，不具有法律效力，北京宇久科技有限公司仅在制作品质及邮寄环节中承担相应责任。</p>
			</div>

		</div>

	</div>
</template>

<script>
	import layout from '@/view/layout/index.vue'
	export default {
		name: 'metalcertificatecenter',
		components: {
			layout: layout
		},
		methods:{
			downloadHzd:function(){
				window.location.href = "/static/metalcertificate/hz.doc";
			}
		}
	}
</script>

<style scoped>
	.navbar-header h1,
	p {
		color: #333;
	}

	.cpzs-title{
		color: #165aa5;
	    line-height: 45px;
	    height: 45px;
	    font-size: 40px;
	    font-weight: normal;
	    text-decoration: none;
	    text-align: center;
	    margin: 20px;
	}

	.cpzs-smbt{
		font-size: 16px;
		margin-bottom: 15px;
	}
	.cpzs-smnr{
		font-size: 20px;
	}

	.cpzs-content{
		padding: 0 10%;
		font-size: 16px;
	}
	.cpzs-content p{
		margin: 15px 0;
	}
</style>



// WEBPACK FOOTER //
// src/view/metalcertificate/metalcertificate.vue